import React from "react";
import {formatUkNumber} from "../../Utils";
export default({ data })=> {
  const {
    total=0,
    participantCount=0,
    joinedParticipants=0,
    bookedParticipants=0,
    invitedParticipants=0,
  } = data;

  const stats = [
    { label: "Total Sessions", value: total, color: "primary" },
    { label: "Patients Invited", value: invitedParticipants, color: "info" },
    { label: "Booked", value: bookedParticipants, color: "warning" },
    { label: "Attended", value: joinedParticipants, color: "success" },
    { label: "Total Participants", value: participantCount, color: "secondary" },
  ];

  return (
    <div className="d-flex flex-wrap align-items-center gap-2 mb-4">
      {stats.map((s, i) => (
        <React.Fragment key={s.label}>
          {i !== 0 && <span className="text-muted">|</span>}
          <span className={`  py-2`}>
            {s.label}: {formatUkNumber(s.value)}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}
